import api from "../api";

export function getOffice() {
    return api.get('/dashboard/offices/fetch');
}

export function getOfficeTypes() {
    return api.get('/dashboard/offices/fetch-types');
}

export function addOffice(FormData: FormData) {
    return api.post('/dashboard/offices/store', FormData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export function getOfficeById(id: number) {
    return api.get(`/dashboard/offices/fetch-single/${id}`);
}

export function deleteOffice(id: number) {
    const formData = new FormData();
    formData.append('id', String(id));

    return api.post('/dashboard/offices/delete', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export function updateOffice(FormData: FormData, id: number) {
    return api.post(`/dashboard/offices/update/${id}`, FormData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}
